import React from "react";
import { styled, Theme, CSSObject } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";

import SidebarContent from "./header/SidebarContent";

import { useAppDispatch, useAppSelector } from "../app/hooks";
import {
  selectPreference,
  toggleThis,
} from "../features/preferences/preferencesSlice";
import { SwipeableDrawer } from "@mui/material";
import { useTranslation } from "react-i18next";
const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: "0px",
  //width: `calc(${theme.spacing(7)} + 1px)`,
  // [theme.breakpoints.up("sm")]: {
  //   width: `calc(${theme.spacing(9)} + 1px)`,
  // },
});

export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  //justifyContent: 'flex-end',
  //padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  //...theme.mixins.toolbar,
  justifyContent: "space-between",
  backgroundColor: theme.palette.primary.main,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

const DashboardSidebar = () => {
  const dispatch = useAppDispatch();

  const { isMobileDrawerOpen, isDrawerOpen } = useAppSelector(selectPreference);

  const handleDrawerToggle = () => {
    dispatch(toggleThis({ type: "Mobile", newValue: !isMobileDrawerOpen }));
  };
  const { i18n } = useTranslation();

  return (
    <Box sx={{ backgroundColor: "transparent" }}>
      {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
      <SwipeableDrawer
        disableBackdropTransition={!iOS}
        disableDiscovery={iOS}
        variant="temporary"
        anchor={i18n.dir() === "rtl" ? "right" : "left"}
        onClose={handleDrawerToggle}
        open={!!isMobileDrawerOpen}
        onOpen={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", lg: "none" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
        }}
      >
        <SidebarContent />
      </SwipeableDrawer>
      <Drawer
        PaperProps={{ sx: { backgroundColor: "transparent", opacity: "1" } }}
        variant="permanent"
        anchor={i18n.dir() === "rtl" ? "right" : "left"}
        sx={{
          display: { xs: "none", lg: "block" },
        }}
        open={!!isDrawerOpen}
      >
        <>
          <SidebarContent />
        </>
      </Drawer>
    </Box>
  );
};

export default DashboardSidebar;
